'use client';

import { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';

import { Button } from '@/elements/button/button.component';
import { FormControl, Input, Label } from '@/styles/global.elements';
import { Container, Inputs, FormRow } from './contact-form.elements';

import { checkEmail, checkAlpha } from '@/utils/form-validation.utils';
import { submitContactForm } from '@/actions/submit-contact-form.action';

const ContactForm = ({ type = 'contact', setShowModal }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    type,
  });
  const [isSending, setIsSending] = useState(false);
  const reRef = useRef();

  const submitMessage = async () => {
    setIsSending(true);

    try {
      /* Google reCAPTCHA */
      const token = await reRef.current.executeAsync();

      const data = await submitContactForm({ formData, token });

      if (data.success) {
        toast.info('Tvoja poruka je poslana. Hvala!');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          message: '',
        });

        if (setShowModal) setShowModal(false);
      } else {
        toast.error('Došlo je do greške. Molimo pokušaj ponovno.');
      }
    } catch {
      toast.error('Došlo je do greške. Molimo pokušaj ponovno.');
    } finally {
      setTimeout(() => setIsSending(false), 3000);
    }
  };

  const sendMessage = (e) => {
    e.preventDefault();
    submitMessage();
  };

  const emailValidation = (target) => {
    if (target.length > 0 && !checkEmail(target)) return 'invalid';
    else if (checkEmail(target)) return 'valid';
    return null;
  };

  const alphaValidation = (target) => {
    if (target.length > 0 && !checkAlpha(target)) return 'invalid';
    else if (target.length > 0 && checkAlpha(target)) return 'valid';
    return null;
  };

  const enableSubmit =
    formData.firstName.length > 0 &&
    formData.lastName.length > 0 &&
    formData.message.length > 0 &&
    checkAlpha(formData.firstName) &&
    checkAlpha(formData.lastName) &&
    checkEmail(formData.email) &&
    !isSending;

  return (
    <>
      <Container onSubmit={sendMessage}>
        <Inputs>
          <FormRow>
            <FormControl>
              <Label>Ime:</Label>
              <Input
                name="firstName"
                type="text"
                value={formData.firstName}
                onChange={(e) => setFormData((prev) => ({ ...prev, firstName: e.target.value }))}
                placeholder="Upiši ime"
                $status={alphaValidation(formData.firstName)}
              />
            </FormControl>
            <FormControl>
              <Label>Prezime:</Label>
              <Input
                name="lastName"
                type="text"
                value={formData.lastName}
                onChange={(e) => setFormData((prev) => ({ ...prev, lastName: e.target.value }))}
                placeholder="Upiši prezime"
                $status={alphaValidation(formData.lastName)}
              />
            </FormControl>
          </FormRow>
          <FormControl>
            <Label>Email:</Label>
            <Input
              name="email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData((prev) => ({ ...prev, email: e.target.value }))}
              placeholder="Upiši email adresu"
              $status={emailValidation(formData.email)}
            />
          </FormControl>
          <FormControl>
            <Label>{type === 'order' ? 'Tema edukacije:' : 'Poruka:'}</Label>
            <Input
              name="message"
              as="textarea"
              type="text"
              rows={5}
              value={formData.message}
              onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))}
              placeholder={type === 'order' ? 'Opiši edukaciju koju trebaš' : 'Upiši poruku ovdje'}
            />
          </FormControl>
        </Inputs>
        <Button disabled={!enableSubmit} width="auto" background="light">
          Pošalji
        </Button>
        <ReCAPTCHA
          sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
          size="invisible"
          ref={reRef}
        />
      </Container>
    </>
  );
};
export { ContactForm };
